(function () {
  'use strict';

  // Coordenadas "lógicas": el diseño siempre vive en un lienzo de 1000px de ancho,
  // y solo se hace zoom para mostrarlo. Así el resize nunca mueve ni deforma nada.
  var LOGICAL_W = 1000;
  var BASE_FONT_SIZE = 100;
  var BRAND = '#273a7e';

  // ------------------------------------------------------------
  // Configuración por defecto (se puede sobreescribir con
  // window.CubittCustomizerConfig = { fonts: [...], colors: [...], icons: {...} })
  // ------------------------------------------------------------
  var DEFAULT_FONTS = [
    { name: 'Montserrat', family: 'Montserrat', bold: true, italic: true },
    { name: 'Bebas Neue', family: 'Bebas Neue' },
    { name: 'Playfair Display', family: 'Playfair Display', bold: true, italic: true },
    { name: 'Cinzel', family: 'Cinzel', bold: true },
    { name: 'Righteous', family: 'Righteous' },
    { name: 'Oswald', family: 'Oswald', bold: true },
    { name: 'Courier Prime', family: 'Courier Prime', bold: true, italic: true },
    { name: 'Pacifico', family: 'Pacifico' },
    { name: 'Dancing Script', family: 'Dancing Script', bold: true },
    { name: 'Great Vibes', family: 'Great Vibes' },
    { name: 'Lobster', family: 'Lobster' }
  ];

  // `stops` = acabado metálico (degradado). `hex` = color sólido.
  var DEFAULT_COLORS = [
    { name: 'Laser engraved', stops: ['#eceef1', '#a3a9b0', '#dfe2e6', '#8a9098'], shadow: true },
    { name: 'Gold', stops: ['#fbe8a6', '#c79f45', '#f5da88', '#a5802d'], shadow: true },
    { name: 'Rose gold', stops: ['#f9d6ca', '#bf8373', '#f2c3b3', '#a66a5a'], shadow: true },
    { name: 'White', hex: '#ffffff' },
    { name: 'Black', hex: '#161616' },
    { name: 'Navy', hex: '#1f2c5c' },
    { name: 'Royal blue', hex: '#2f4fd1' },
    { name: 'Sky', hex: '#86bde8' },
    { name: 'Red', hex: '#c8242f' },
    { name: 'Coral', hex: '#f2795f' },
    { name: 'Pink', hex: '#f3a8c4' },
    { name: 'Yellow', hex: '#f4cf3c' },
    { name: 'Mint', hex: '#8fd3bf' },
    { name: 'Forest', hex: '#2e5e45' },
    { name: 'Grey', hex: '#8a8f96' }
  ];

  // Íconos simples (grilla 24x24).
  var DEFAULT_ICONS = {
    heart: { name: 'Heart', d: 'M12 21s-7.5-4.6-10-9.3C.4 8.4 2.3 4 6.3 4c2.3 0 3.9 1.3 5.7 3.4C13.8 5.3 15.4 4 17.7 4c4 0 5.9 4.4 4.3 7.7C19.5 16.4 12 21 12 21z' },
    star: { name: 'Star', d: 'M12 2l2.9 6.6 7.1.6-5.4 4.7 1.6 7L12 17.3 5.8 20.9l1.6-7L2 9.2l7.1-.6z' },
    bolt: { name: 'Bolt', d: 'M13 2L4 14h7l-1 8 9-12h-7z' },
    mountain: { name: 'Mountain', d: 'M1 20L8.5 7l4.2 7 2.8-4L23 20z' },
    sun: { name: 'Sun', d: 'M12 7a5 5 0 1 0 0 10a5 5 0 1 0 0-10z M11 0h2v4h-2z M11 20h2v4h-2z M0 11h4v2H0z M20 11h4v2h-4z M3.5 5l1.5-1.5 2.8 2.8-1.5 1.5z M16.2 17.7l1.5-1.5 2.8 2.8-1.5 1.5z M3.5 19l2.8-2.8 1.5 1.5L5 20.5z M16.2 6.3L19 3.5 20.5 5l-2.8 2.8z' },
    cup: { name: 'Coffee', d: 'M3 8h14v5a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6z M17 9.5h1.5a3.5 3.5 0 0 1 0 7H16v-2.2h2.5a1.3 1.3 0 0 0 0-2.6H17z' }
  };

  var DEFAULTS = {
    productTitle: '',
    image: null,
    useVariantImages: true,
    variantImages: {},
    area: { x: 35, y: 44, w: 29, h: 32 },
    maxChars: 20,
    fee: '',
    placeholder: 'YOUR NAME',
    initialSize: 80,
    // Fase 2 (carrito)
    price: 0,
    variantPrices: {},
    variantAvailable: {},
    currency: 'USD',
    feeVariantId: null,
    feePrice: 0,
    custom: null,
    logoMaxMB: 5,
    // 'gray' = logo real en escala de grises (sin vectorizar) · 'original' = colores reales · 'engrave' = silueta plana
    logoMode: 'gray'
  };

  // ------------------------------------------------------------
  // Utilidades
  // ------------------------------------------------------------
  function qs(el, sel) { return el.querySelector(sel); }
  function qsa(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }
  function swatchCss(c) {
    return c.stops ? 'linear-gradient(160deg,' + c.stops.join(',') + ')' : c.hex;
  }

  // ============================================================
  // Customizer
  // ============================================================
  function Customizer(root) {
    this.root = root;

    var raw = {};
    var cfgEl = qs(root, '[data-cc-config]');
    try { raw = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { console.error('[Cubitt] Invalid config JSON', e); }
    var override = window.CubittCustomizerConfig || {};
    this.cfg = Object.assign({}, DEFAULTS, raw, override);
    this.cfg.area = Object.assign({}, DEFAULTS.area, raw.area, override.area);

    // Metafield JSON custom.customizer (opcional): sobreescribe área, caracteres, etc.
    var custom = this.cfg.custom;
    if (custom && typeof custom === 'object') {
      if (custom.area) this.cfg.area = Object.assign({}, this.cfg.area, custom.area);
      ['maxChars', 'placeholder', 'initialSize'].forEach(function (k) {
        if (custom[k] != null) this.cfg[k] = custom[k];
      }, this);
    }
    this.debug = /[?&]cc_debug=1\b/.test(location.search);
    this.qty = 1;
    this.busy = false;
    this.logoFile = null;
    this.logoEl = null;

    this.fonts = override.fonts || DEFAULT_FONTS;
    this.colors = override.colors || DEFAULT_COLORS;
    this.icons = override.icons || DEFAULT_ICONS;

    this.modal = qs(root, '[data-cc-modal]');
    this.state = {
      line1: '', line2: '', twoLines: false,
      font: 0, color: 0,
      bold: false, italic: false, upper: true,
      align: 'center', spacing: 0,
      icon: null
    };

    this.canvas = null;
    this.text = null;
    this.icon = null;
    this.guide = null;
    this.imageUrl = null;
    this.logicalH = LOGICAL_W;
    this.fontLoaded = {};
    this.queue = Promise.resolve();

    this.buildFonts();
    this.buildColors();
    this.buildIcons();
    this.bind();
    this.syncStyleButtons();
    this.placeAboveAtc();
  }

  Customizer.prototype.$ = function (sel) { return qs(this.modal, sel); };
  Customizer.prototype.$$ = function (sel) { return qsa(this.modal, sel); };

  // ------------------------------------------------------------
  // Construcción de UI
  // ------------------------------------------------------------
  Customizer.prototype.buildFonts = function () {
    var self = this;
    var list = this.$('.cc-select-list');
    this.fonts.forEach(function (f, i) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.setAttribute('tabindex', '-1');
      li.dataset.index = i;
      li.textContent = f.name;
      li.style.fontFamily = '"' + f.family + '", sans-serif';
      li.addEventListener('click', function () { self.selectFont(i); self.toggleFontList(false); });
      list.appendChild(li);
    });
    this.updateFontLabel();

    // Fondo para el selector tipo "bottom sheet" en móvil
    var bd = document.createElement('div');
    bd.className = 'cc-sheet-backdrop';
    bd.hidden = true;
    bd.addEventListener('click', function () { self.toggleFontList(false); });
    this.modal.querySelector('.cc-dialog').appendChild(bd);
    this.fontBackdrop = bd;
  };

  Customizer.prototype.buildColors = function () {
    var self = this;
    var wrap = this.$('[data-cc-colors]');
    this.colors.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cc-swatch' + (c.stops ? ' cc-swatch--metal' : '') + (c.hex && c.hex.toLowerCase() === '#ffffff' ? ' cc-swatch--light' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', c.name);
      b.title = c.name;
      b.style.background = swatchCss(c);
      b.addEventListener('click', function () { self.selectColor(i); });
      wrap.appendChild(b);
    });
    this.selectColor(this.state.color, true);
  };

  Customizer.prototype.buildIcons = function () {
    var self = this;
    var wrap = this.$('[data-cc-icons]');
    var keys = [null].concat(Object.keys(this.icons));
    keys.forEach(function (key) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cc-icon-opt';
      b.setAttribute('role', 'radio');
      b.dataset.icon = key || '';
      if (key) {
        b.title = self.icons[key].name;
        b.setAttribute('aria-label', self.icons[key].name);
        b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + self.icons[key].d + '"/></svg>';
      } else {
        b.title = 'No icon';
        b.setAttribute('aria-label', 'No icon');
        b.innerHTML = '<span>None</span>';
      }
      b.addEventListener('click', function () { self.selectIcon(key); });
      wrap.appendChild(b);
      if (!key && self.cfg.allowLogo !== false) wrap.appendChild(self.buildLogoButton());
    });
    this.markIcon();
  };

  // ------------------------------------------------------------
  // Eventos de UI
  // ------------------------------------------------------------
  Customizer.prototype.bind = function () {
    var self = this;

    qsa(this.root, '[data-cc-open]').forEach(function (b) {
      b.addEventListener('click', function () { self.open(); });
    });
    this.$$('[data-cc-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });

    this.onKey = function (e) {
      if (e.key === 'Escape') {
        if (!self.$('.cc-select-list').hidden) self.toggleFontList(false);
        else self.close();
      }
    };

    // Texto
    var maxChars = parseInt(this.cfg.maxChars, 10) || 20;
    this.$$('[data-cc-line]').forEach(function (input) {
      input.maxLength = maxChars;
      input.addEventListener('input', function () {
        self.state['line' + input.dataset.ccLine] = input.value;
        self.clearFieldErrors();
        self.updateCounter(input);
        self.refreshText();
      });
      input.addEventListener('focus', function () { self.updateCounter(input); });
    });
    this.updateCounter(this.$('[data-cc-line="1"]'));

    this.$('[data-cc-toggle-line2]').addEventListener('click', function () {
      self.state.twoLines = !self.state.twoLines;
      self.$('[data-cc-line2-wrap]').hidden = !self.state.twoLines;
      this.textContent = self.state.twoLines ? '− Remove second line' : '+ Add a second line';
      if (self.state.twoLines) self.$('[data-cc-line="2"]').focus();
      self.syncStyleButtons();
      self.refreshText();
    });

    // Font dropdown
    var selBtn = this.$('.cc-select-btn');
    selBtn.addEventListener('click', function () {
      self.toggleFontList(self.$('.cc-select-list').hidden);
    });
    this.$('.cc-select-list').addEventListener('keydown', function (e) {
      var items = self.$$('.cc-select-list li');
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); items[clamp(i + 1, 0, items.length - 1)].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); items[clamp(i - 1, 0, items.length - 1)].focus(); }
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (i >= 0) { self.selectFont(i); self.toggleFontList(false); selBtn.focus(); }
      }
    });
    document.addEventListener('click', function (e) {
      var sel = self.$('[data-cc-font]');
      if (sel && !sel.contains(e.target)) self.toggleFontList(false);
    });

    // Tamaño
    var size = this.$('[data-cc-size]');
    size.addEventListener('input', function () { self.setSizePct(parseFloat(size.value)); });
    this.$$('[data-cc-size-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.setSizePct(clamp(parseFloat(size.value) + parseFloat(b.dataset.ccSizeStep), 10, 100));
      });
    });

    // Estilo
    this.$$('[data-cc-style]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.ccStyle;
        self.state[k] = !self.state[k];
        self.syncStyleButtons();
        self.refreshText();
      });
    });
    this.$$('[data-cc-align]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.state.align = b.dataset.ccAlign;
        self.syncStyleButtons();
        self.refreshText();
      });
    });

    var spacing = this.$('[data-cc-spacing]');
    spacing.addEventListener('input', function () {
      self.state.spacing = parseInt(spacing.value, 10);
      self.$('[data-cc-spacing-value]').textContent = self.state.spacing;
      self.refreshText();
    });
    this.$('[data-cc-spacing-value]').textContent = '0';

    var rot = this.$('[data-cc-rotation]');
    rot.addEventListener('input', function () { self.setRotation(parseFloat(rot.value)); });
    this.$('[data-cc-rotation-value]').textContent = '0°';

    // Herramientas del mockup
    this.$$('[data-cc-center]').forEach(function (b) {
      b.addEventListener('click', function () { self.centerTarget(b.dataset.ccCenter); });
    });
    this.$('[data-cc-reset]').addEventListener('click', function () { self.resetLayout(); });

    // Acciones
    var dl = this.$('[data-cc-download]');
    if (dl) dl.addEventListener('click', function () { self.download(); });
    var doneBtn = this.$('[data-cc-done]');
    if (doneBtn) doneBtn.addEventListener('click', function () { self.done(); });

    // Cantidad + Add to cart
    var qtyInput = this.$('[data-cc-qty]');
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { self.setQty(parseInt(qtyInput.value, 10)); });
      this.$$('[data-cc-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () { self.setQty(self.qty + parseInt(b.dataset.ccQtyStep, 10)); });
      });
    }
    var addBtn = this.$('[data-cc-add]');
    if (addBtn) addBtn.addEventListener('click', function () { self.addToCart(); });

    // Resize
    this.onResize = function () { if (self.isOpen) self.resize(); };
    window.addEventListener('resize', this.onResize);
    if (window.ResizeObserver) {
      new ResizeObserver(this.onResize).observe(this.$('[data-cc-canvas-wrap]'));
    }
  };

  // ------------------------------------------------------------
  // Abrir / cerrar
  // ------------------------------------------------------------
  Customizer.prototype.open = async function () {
    if (!window.fabric) {
      console.error('[Cubitt] Fabric.js is not loaded');
      return;
    }
    // El modal se mueve al <body> para que ningún transform/overflow del theme lo recorte.
    if (this.modal.parentNode !== document.body) document.body.appendChild(this.modal);

    this.lastFocus = document.activeElement;
    this.modal.hidden = false;
    this.isOpen = true;
    document.documentElement.classList.add('cc-lock');
    document.addEventListener('keydown', this.onKey);
    var modal = this.modal;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    this.$('.cc-close').focus({ preventScroll: true });

    if (!this.canvas) this.initCanvas();

    var url = this.currentImageUrl();
    if (url && url !== this.imageUrl) {
      await this.loadImage(url);
    } else {
      this.resize();
    }
    if (!this.text) await this.createText();

    // Cantidad inicial = la del formulario de la página (si existe)
    var formQty = this.productForm() && this.productForm().querySelector('[name="quantity"]');
    this.setQty(formQty ? parseInt(formQty.value, 10) : this.qty);
    var price = this.$('.cc-price');
    if (price) price.textContent = this.money(this.variantPrice());
    if (!this.cfg.feeVariantId) {
      console.error('[Cubitt] Personalization product not found (handle cubitt-personalization)');
    }
    if (this.debug) this.enableDebug();
  };

  Customizer.prototype.close = function () {
    if (!this.isOpen) return;
    var self = this;
    this.isOpen = false;
    this.toggleFontList(false);
    this.modal.classList.remove('is-open');
    document.removeEventListener('keydown', this.onKey);
    setTimeout(function () {
      self.modal.hidden = true;
      document.documentElement.classList.remove('cc-lock');
      if (self.lastFocus && self.lastFocus.focus) self.lastFocus.focus({ preventScroll: true });
    }, 220);
  };

  // Imagen según la variante seleccionada en la página.
  // Lee el input "id" del formulario de compra de ESTA sección de producto (no el primero de la página,
  // que puede ser un quick-add o el carrito), y si no lo encuentra usa ?variant= de la URL.
  Customizer.prototype.selectedVariantId = function () {
    var main = this.productForm && this.productForm();
    var mainField = main && (main.querySelector('[name="id"]:checked') || main.querySelector('[name="id"]'));
    if (mainField && mainField.value) return String(mainField.value);
    var scope = this.root.closest('.shopify-section, product-info, section, main') || document;
    var forms = qsa(scope, 'form[action*="/cart/add"]');
    if (!forms.length) forms = qsa(document, 'form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var field = forms[i].querySelector('[name="id"]:checked') || forms[i].querySelector('[name="id"]');
      if (field && field.value) return String(field.value);
    }
    return new URLSearchParams(location.search).get('variant');
  };

  Customizer.prototype.currentImageUrl = function () {
    var cfg = this.cfg;
    var id = this.selectedVariantId();
    var url = (id && cfg.variantImages && cfg.variantImages[id]) || cfg.image;
    console.info('[Cubitt] variant:', id, '| image:', id && cfg.variantImages[id] ? 'variant' : 'product fallback');
    return url;
  };

  // ------------------------------------------------------------
  // Canvas
  // ------------------------------------------------------------
  Customizer.prototype.initCanvas = function () {
    var self = this;
    var c = new fabric.Canvas(this.$('[data-cc-canvas]'), {
      selection: false,
      preserveObjectStacking: true,
      uniformScaling: true,
      allowTouchScrolling: false,
      targetFindTolerance: 8
    });
    this.canvas = c;

    c.on('object:moving', function (e) {
      if (e.target === self.guide) return;
      self.keepInside(e.target);
      self.setGuide('active');
    });

    c.on('object:scaling', function (e) {
      var o = e.target;
      if (o === self.guide) return;
      if (!self.isInside(o)) self.restore(o); else self.remember(o);
      self.setGuide('active');
      self.syncSize();
    });

    c.on('object:rotating', function (e) {
      var o = e.target;
      if (o === self.guide) return;
      if (!self.isInside(o)) self.restore(o); else self.remember(o);
      self.setGuide('active');
      self.syncRotation();
    });

    c.on('object:modified', function (e) {
      self.remember(e.target);
      self.setGuide();
      self.syncSize();
      self.syncRotation();
    });

    c.on('mouse:up', function () { self.setGuide(); });
    c.on('selection:created', function () { self.syncTarget(); });
    c.on('selection:updated', function () { self.syncTarget(); });
    c.on('selection:cleared', function () { self.syncTarget(); });
  };

  Customizer.prototype.loadImage = async function (url) {
    var c = this.canvas;
    this.$('[data-cc-loading]').hidden = false;
    try {
      var img = await fabric.FabricImage.fromURL(url, { crossOrigin: 'anonymous' });
      var prevH = this.logicalH;
      var s = LOGICAL_W / img.width;
      this.logicalH = Math.round(img.height * s);
      img.set({ scaleX: s, scaleY: s, left: 0, top: 0, originX: 'left', originY: 'top', selectable: false, evented: false, objectCaching: false });
      c.backgroundImage = img;
      this.matchStageBackground(img.getElement());
      var hadImage = !!this.imageUrl;
      this.imageUrl = url;

      // Si cambia la proporción de la imagen, se reubica el diseño proporcionalmente.
      if (hadImage && prevH !== this.logicalH) {
        var k = this.logicalH / prevH;
        [this.text, this.icon].forEach(function (o) { if (o) { o.top *= k; o.setCoords(); } });
      }
      this.drawGuide();
      if (this.debugOn) { this.debugOn = false; this.enableDebug(); }
      this.resize();
      [this.text, this.icon].forEach(function (o) { if (o) this.keepInside(o); }, this);
    } catch (err) {
      console.error('[Cubitt] Could not load product image', url, err);
    }
    this.$('[data-cc-loading]').hidden = true;
  };

  // Rellena el espacio alrededor del mockup con el color de los bordes de la foto,
  // para que se vea como una sola imagen de lado a lado.
  Customizer.prototype.matchStageBackground = function (el) {
    var wrap = this.$('[data-cc-canvas-wrap]');
    try {
      var k = document.createElement('canvas');
      k.width = 1; k.height = 2;
      var ctx = k.getContext('2d');
      var w = el.naturalWidth || el.width, h = el.naturalHeight || el.height;
      ctx.drawImage(el, 0, 0, 4, 4, 0, 0, 1, 1);
      ctx.drawImage(el, 0, h - 4, 4, 4, 0, 1, 1, 1);
      var d = ctx.getImageData(0, 0, 1, 2).data;
      var top = 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')';
      var bottom = 'rgb(' + d[4] + ',' + d[5] + ',' + d[6] + ')';
      wrap.style.background = 'linear-gradient(' + top + ',' + bottom + ')';
    } catch (e) {
      wrap.style.background = '';
    }
  };

  Customizer.prototype.resize = function () {
    var c = this.canvas;
    if (!c) return;
    var wrap = this.$('[data-cc-canvas-wrap]');
    var availW = wrap.clientWidth;
    // Móvil: la imagen ocupa todo el ancho y crece en alto hasta un 60% de la pantalla.
    // Desktop: ocupa todo el ancho de la columna, salvo que la imagen sea más alta que el modal.
    var mobile = window.matchMedia('(max-width: 860px)').matches;
    var availH = mobile ? window.innerHeight * 0.6 : (wrap.clientHeight || availW);
    var ratio = LOGICAL_W / this.logicalH;
    var w = Math.floor(Math.min(availW, availH * ratio));
    if (w <= 0) return;
    c.setDimensions({ width: w, height: Math.round(w / ratio) });
    c.setZoom(w / LOGICAL_W);
    c.requestRenderAll();
  };

  // Zona grabable en coordenadas lógicas
  Customizer.prototype.area = function () {
    var a = this.cfg.area;
    return {
      left: (a.x / 100) * LOGICAL_W,
      top: (a.y / 100) * this.logicalH,
      width: (a.w / 100) * LOGICAL_W,
      height: (a.h / 100) * this.logicalH
    };
  };

  Customizer.prototype.drawGuide = function () {
    var a = this.area();
    if (this.guide) this.canvas.remove(this.guide);
    this.guide = new fabric.Rect({
      left: a.left, top: a.top, width: a.width, height: a.height,
      originX: 'left', originY: 'top',
      fill: 'rgba(255,255,255,0.04)',
      stroke: 'rgba(255,255,255,0.9)',
      strokeWidth: 1.5,
      strokeDashArray: [7, 6],
      strokeUniform: true,
      shadow: new fabric.Shadow({ color: 'rgba(0,0,0,0.45)', blur: 3 }),
      rx: 6, ry: 6,
      selectable: false, evented: false, excludeFromExport: true,
      objectCaching: false,
      opacity: 0
    });
    this.canvas.add(this.guide);
    this.canvas.sendObjectToBack(this.guide);
  };

  // Guía visible: 'active' mientras se arrastra, tenue con algo seleccionado, oculta si no.
  Customizer.prototype.setGuide = function (mode) {
    if (!this.guide) return;
    if (this.debugOn) { this.guide.set('opacity', 1); this.canvas.requestRenderAll(); return; }
    var selected = !!this.canvas.getActiveObject();
    this.guide.set('opacity', mode === 'active' ? 1 : selected ? 0.45 : 0);
    this.canvas.requestRenderAll();
  };

  // ------------------------------------------------------------
  // Límites
  // ------------------------------------------------------------
  Customizer.prototype.isInside = function (o) {
    o.setCoords();
    var b = o.getBoundingRect();
    var a = this.area();
    var t = 0.5;
    return b.left >= a.left - t && b.top >= a.top - t &&
      b.left + b.width <= a.left + a.width + t &&
      b.top + b.height <= a.top + a.height + t;
  };

  Customizer.prototype.keepInside = function (o) {
    o.setCoords();
    var b = o.getBoundingRect();
    var a = this.area();
    var dx = 0, dy = 0;
    if (b.width > a.width) dx = (a.left + a.width / 2) - (b.left + b.width / 2);
    else if (b.left < a.left) dx = a.left - b.left;
    else if (b.left + b.width > a.left + a.width) dx = a.left + a.width - (b.left + b.width);
    if (b.height > a.height) dy = (a.top + a.height / 2) - (b.top + b.height / 2);
    else if (b.top < a.top) dy = a.top - b.top;
    else if (b.top + b.height > a.top + a.height) dy = a.top + a.height - (b.top + b.height);
    if (dx || dy) {
      o.set({ left: o.left + dx, top: o.top + dy });
      o.setCoords();
    }
  };

  // Escala máxima a la que el objeto todavía cabe en la zona (con su rotación actual)
  Customizer.prototype.maxScale = function (o) {
    o.setCoords();
    var b = o.getBoundingRect();
    var a = this.area();
    if (!b.width || !b.height) return o.scaleX;
    return o.scaleX * Math.min(a.width / b.width, a.height / b.height);
  };

  Customizer.prototype.fitInside = function (o) {
    var m = this.maxScale(o);
    if (o.scaleX > m) o.scale(m * 0.999);
    this.keepInside(o);
  };

  Customizer.prototype.remember = function (o) {
    o._ccValid = { scaleX: o.scaleX, scaleY: o.scaleY, left: o.left, top: o.top, angle: o.angle };
  };

  Customizer.prototype.restore = function (o) {
    if (o._ccValid) { o.set(o._ccValid); o.setCoords(); }
  };

  Customizer.prototype.styleControls = function (o) {
    o.set({
      originX: 'center', originY: 'center',
      borderColor: BRAND, cornerColor: '#ffffff', cornerStrokeColor: BRAND,
      cornerStyle: 'circle', transparentCorners: false, cornerSize: 13,
      borderScaleFactor: 1.5, padding: 8,
      lockScalingFlip: true, snapAngle: 45, snapThreshold: 4,
      objectCaching: false // nitidez: dibuja directo en el canvas (retina), sin bitmap intermedio
    });
    // Solo esquinas (escala proporcional) + rotación
    o.setControlsVisibility({ ml: false, mr: false, mt: false, mb: false });
  };

  // ------------------------------------------------------------
  // Texto
  // ------------------------------------------------------------
  Customizer.prototype.createText = async function () {
    var a = this.area();
    var t = new fabric.FabricText(' ', {
      left: a.left + a.width / 2,
      top: a.top + a.height / 2,
      fontSize: BASE_FONT_SIZE,
      lineHeight: 1.05,
      textAlign: 'center'
    });
    this.styleControls(t);
    t.ccRole = 'text';
    this.text = t;
    this.canvas.add(t);
    await this.applyText();
    this.setSizePct(this.cfg.initialSize, t);
    this.canvas.setActiveObject(t);
    this.syncTarget();
    this.setGuide();
  };

  Customizer.prototype.ensureFont = async function (family, weight, style) {
    var key = family + '|' + weight + '|' + style;
    if (this.fontLoaded[key]) return;
    try {
      await document.fonts.load(style + ' ' + weight + ' 100px "' + family + '"', 'ABCabc');
    } catch (e) { /* se usa la fuente de respaldo */ }
    this.fontLoaded[key] = true;
    if (fabric.cache && fabric.cache.clearFontCache) fabric.cache.clearFontCache(family);
  };

  // Las actualizaciones se encolan para que una fuente que tarda en cargar no pise un cambio más reciente.
  Customizer.prototype.refreshText = function () {
    var self = this;
    this.queue = this.queue.then(function () { return self.applyText(); }).catch(function (e) { console.error(e); });
    return this.queue;
  };

  Customizer.prototype.applyText = async function () {
    var t = this.text;
    if (!t) return;
    var s = this.state;
    var font = this.fonts[s.font];
    var weight = s.bold && font.bold ? 700 : 400;
    var style = s.italic && font.italic ? 'italic' : 'normal';
    await this.ensureFont(font.family, weight, style);

    var l1 = s.line1.trim();
    var l2 = s.twoLines ? s.line2.trim() : '';
    var str = l2 ? (l1 || ' ') + '\n' + l2 : l1;
    var empty = !str.trim();
    if (empty) str = this.cfg.placeholder;
    if (s.upper) str = str.toUpperCase();

    t.set({
      text: str,
      fontFamily: font.family,
      fontWeight: weight,
      fontStyle: style,
      charSpacing: s.spacing,
      textAlign: l2 ? s.align : 'center',
      opacity: empty ? 0.6 : 1
    });
    t.initDimensions();
    this.applyFill(t);
    this.fitInside(t);
    this.remember(t);

    // Sin texto + con ícono/logo: el texto de muestra desaparece del preview
    var hide = empty && !!s.icon;
    var wasHidden = t.visible === false;
    t.set({ visible: !hide, selectable: !hide, evented: !hide });
    if (hide && this.canvas.getActiveObject() === t) this.canvas.setActiveObject(this.icon);
    if (this.icon && hide !== wasHidden) this.placeIcon();
    this.syncTarget();
    this.canvas.requestRenderAll();
  };

  Customizer.prototype.applyFill = function (o) {
    if (o.ccRole === 'logo') return;
    var c = this.colors[this.state.color];
    if (c.stops) {
      var n = c.stops.length - 1;
      o.set('fill', new fabric.Gradient({
        type: 'linear',
        gradientUnits: 'percentage',
        coords: { x1: 0, y1: 0, x2: 0, y2: 1 },
        colorStops: c.stops.map(function (color, i) { return { offset: i / n, color: color }; })
      }));
    } else {
      o.set('fill', c.hex);
    }
    o.set('shadow', c.shadow ? new fabric.Shadow({ color: 'rgba(0,0,0,0.22)', blur: 1, offsetX: 0, offsetY: 1 }) : null);
    o.dirty = true;
  };

  // ------------------------------------------------------------
  // Selecciones del panel
  // ------------------------------------------------------------
  Customizer.prototype.toggleFontList = function (show) {
    var list = this.$('.cc-select-list');
    var btn = this.$('.cc-select-btn');
    if (!list) return;
    list.hidden = !show;
    btn.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (this.fontBackdrop) this.fontBackdrop.hidden = !show;
    this.modal.classList.toggle('cc-sheet-open', !!show);
    if (show) {
      var cur = list.children[this.state.font];
      if (cur) { cur.focus({ preventScroll: true }); cur.scrollIntoView({ block: 'nearest' }); }
    }
  };

  Customizer.prototype.updateFontLabel = function () {
    var f = this.fonts[this.state.font];
    var cur = this.$('[data-cc-font-current]');
    cur.textContent = f.name;
    cur.style.fontFamily = '"' + f.family + '", sans-serif';
    this.$$('.cc-select-list li').forEach(function (li, i) {
      li.setAttribute('aria-selected', i === this.state.font ? 'true' : 'false');
    }, this);
  };

  Customizer.prototype.selectFont = function (i) {
    this.state.font = i;
    this.updateFontLabel();
    this.syncStyleButtons();
    this.refreshText();
  };

  Customizer.prototype.selectColor = function (i, silent) {
    this.state.color = i;
    this.$$('.cc-swatch').forEach(function (b, j) { b.setAttribute('aria-checked', j === i ? 'true' : 'false'); });
    this.$('[data-cc-color-name]').textContent = this.colors[i].name;
    if (silent) return;
    if (this.text) this.applyFill(this.text);
    if (this.icon) this.applyFill(this.icon);
    if (this.canvas) this.canvas.requestRenderAll();
  };

  Customizer.prototype.syncStyleButtons = function () {
    var s = this.state;
    var f = this.fonts[s.font];
    this.$$('[data-cc-style]').forEach(function (b) {
      var k = b.dataset.ccStyle;
      var supported = k === 'upper' || !!f[k];
      if (!b.dataset.baseTitle) b.dataset.baseTitle = b.title;
      b.disabled = !supported;
      b.title = b.dataset.baseTitle + (supported ? '' : ' (not available for this font)');
      b.setAttribute('aria-pressed', s[k] && supported ? 'true' : 'false');
    });
    this.$$('[data-cc-align]').forEach(function (b) {
      b.disabled = !s.twoLines;
      b.setAttribute('aria-pressed', b.dataset.ccAlign === s.align ? 'true' : 'false');
    });
  };

  Customizer.prototype.updateCounter = function (input) {
    var max = parseInt(this.cfg.maxChars, 10) || 20;
    var left = max - input.value.length;
    this.$('[data-cc-counter]').textContent = left + (left === 1 ? ' character left' : ' characters left');
  };

  // ------------------------------------------------------------
  // Íconos
  // ------------------------------------------------------------
  Customizer.prototype.selectIcon = function (key) {
    var c = this.canvas;
    this.state.icon = key;
    this.markIcon();
    if (!c) return;
    if (this.icon) { c.remove(this.icon); this.icon = null; }
    if (key === 'logo' && !this.logoEl) {
      this.state.icon = null;
      this.markIcon();
      key = null;
    }
    if (key) {
      var p = key === 'logo'
        ? new fabric.FabricImage(this.logoEl, {})
        : new fabric.Path(this.icons[key].d, {});
      this.styleControls(p);
      p.ccRole = key === 'logo' ? 'logo' : 'icon';
      this.icon = p;
      this.applyFill(p);
      c.add(p);
      this.placeIcon();
      c.setActiveObject(p);
    } else if (this.text) {
      c.setActiveObject(this.text);
    }
    this.clearFieldErrors();
    this.refreshText();
    this.syncTarget();
    this.setGuide();
    c.requestRenderAll();
  };

  // Coloca el ícono encima del texto si hay espacio; si no, en la parte alta de la zona.
  Customizer.prototype.placeIcon = function () {
    var p = this.icon;
    if (!p) return;
    var a = this.area();
    var alone = !this.hasText();
    var k = alone ? 1.6 : 1;
    if (p.ccRole === 'logo') {
      p.scale(Math.min((a.width * 0.55 * k) / p.width, (a.height * 0.4 * k) / p.height));
    } else {
      var size = Math.min(a.height * 0.3, a.width * 0.25) * k;
      p.scale(size / Math.max(p.width, p.height));
    }
    p.set({ angle: 0, left: a.left + a.width / 2 });
    var h = p.getScaledHeight();
    var top = a.top + h / 2;
    if (alone) {
      top = a.top + a.height / 2;
    } else if (this.text) {
      this.text.setCoords();
      var tb = this.text.getBoundingRect();
      top = Math.max(top, tb.top - 10 - h / 2);
    }
    p.set('top', top);
    this.keepInside(p);
    this.remember(p);
  };

  Customizer.prototype.markIcon = function () {
    var cur = this.state.icon || '';
    this.$$('.cc-icon-opt').forEach(function (b) {
      b.setAttribute('aria-checked', b.dataset.icon === cur ? 'true' : 'false');
    });
  };

  // ------------------------------------------------------------
  // Tamaño / rotación / posición (aplican al elemento seleccionado)
  // ------------------------------------------------------------
  Customizer.prototype.target = function () {
    var active = this.canvas && this.canvas.getActiveObject();
    if (active && active !== this.guide) return active;
    if (this.text && this.text.visible === false && this.icon) return this.icon;
    return this.text;
  };

  Customizer.prototype.hasText = function () {
    var s = this.state;
    return !!(s.line1.trim() || (s.twoLines && s.line2.trim()));
  };

  Customizer.prototype.syncTarget = function () {
    var o = this.target();
    var label = this.$('[data-cc-target-label]');
    if (label) label.textContent = o && o.ccRole === 'logo' ? '· logo' : (o && o.ccRole === 'icon' ? '· icon' : '· text');
    this.syncSize();
    this.syncRotation();
    this.setGuide();
  };

  Customizer.prototype.setSizePct = function (pct, obj) {
    var o = obj || this.target();
    if (!o) return;
    var m = this.maxScale(o);
    o.scale(m * clamp(pct, 10, 100) / 100);
    this.keepInside(o);
    this.remember(o);
    this.syncSize();
    this.canvas.requestRenderAll();
  };

  Customizer.prototype.syncSize = function () {
    var o = this.target();
    if (!o) return;
    var pct = Math.round(clamp((o.scaleX / this.maxScale(o)) * 100, 10, 100));
    this.$('[data-cc-size]').value = pct;
    this.$('[data-cc-size-value]').textContent = pct + '%';
  };

  Customizer.prototype.setRotation = function (deg) {
    var o = this.target();
    if (!o) return;
    o.rotate(deg);
    this.fitInside(o);
    this.remember(o);
    this.syncRotation();
    this.syncSize();
    this.canvas.requestRenderAll();
  };

  Customizer.prototype.syncRotation = function () {
    var o = this.target();
    if (!o) return;
    var a = Math.round(o.angle > 180 ? o.angle - 360 : o.angle);
    this.$('[data-cc-rotation]').value = clamp(a, -45, 45);
    this.$('[data-cc-rotation-value]').textContent = a + '°';
  };

  Customizer.prototype.centerTarget = function (axis) {
    var o = this.target();
    if (!o) return;
    var a = this.area();
    if (axis === 'h') o.set('left', a.left + a.width / 2);
    else o.set('top', a.top + a.height / 2);
    this.keepInside(o);
    this.remember(o);
    this.canvas.requestRenderAll();
  };

  Customizer.prototype.resetLayout = function () {
    if (!this.text) return;
    var a = this.area();
    this.text.set({ angle: 0, left: a.left + a.width / 2, top: a.top + a.height / 2 });
    this.setSizePct(this.cfg.initialSize, this.text);
    if (this.icon) this.placeIcon();
    this.canvas.setActiveObject(this.text);
    this.syncTarget();
    this.canvas.requestRenderAll();
  };

  // ------------------------------------------------------------
  // Exportar / guardar
  // ------------------------------------------------------------
  Customizer.prototype.exportImage = function (outWidth, format) {
    var c = this.canvas;
    var active = c.getActiveObject();
    c.discardActiveObject();
    if (this.guide) this.guide.visible = false;
    c.renderAll();
    var url = c.toDataURL({ format: format || 'png', quality: 0.9, multiplier: (outWidth || LOGICAL_W) / c.getWidth() });
    if (this.guide) this.guide.visible = true;
    if (active) c.setActiveObject(active);
    c.requestRenderAll();
    return url;
  };

  Customizer.prototype.describe = function () {
    var s = this.state;
    var txt = [s.line1.trim(), s.twoLines ? s.line2.trim() : ''].filter(Boolean).join(' / ');
    if (s.upper) txt = txt.toUpperCase();
    var parts = [txt ? '“' + txt + '”' : 'No text', this.fonts[s.font].name, this.colors[s.color].name];
    if (s.icon === 'logo') parts.push('Logo');
    else if (s.icon) parts.push(this.icons[s.icon].name + ' icon');
    return parts.join(' · ');
  };

  Customizer.prototype.download = function () {
    if (!this.canvas) return;
    var a = document.createElement('a');
    var slug = (this.state.line1 || 'design').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    a.href = this.exportImage(LOGICAL_W, 'png');
    a.download = 'cubitt-preview-' + (slug || 'design') + '.png';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  // Fase 1: guarda el diseño y lo muestra en la página. (Fase 2: aquí se conectará el carrito.)
  Customizer.prototype.done = function () {
    if (!this.canvas) return;
    var summary = qs(this.root, '[data-cc-summary]');
    qs(this.root, '[data-cc-summary-img]').src = this.exportImage(240, 'jpeg');
    qs(this.root, '[data-cc-summary-text]').textContent = this.describe();
    summary.hidden = false;
    var label = qs(this.root, '[data-cc-open-label]');
    if (label) label.textContent = 'Edit personalization';

    this.root.dispatchEvent(new CustomEvent('cubitt:customized', {
      bubbles: true,
      detail: { state: Object.assign({}, this.state), summary: this.describe() }
    }));
    this.close();
  };

  // ============================================================
  // LOGO (se sube en el panel de íconos y se graba en gris)
  // ============================================================
  Customizer.prototype.buildLogoButton = function () {
    var self = this;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cc-icon-opt cc-icon-opt--logo';
    b.setAttribute('role', 'radio');
    b.dataset.icon = 'logo';
    b.title = 'Upload your logo';
    b.setAttribute('aria-label', 'Upload your logo');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 15V4M7.5 8.5L12 4l4.5 4.5M4 15v5h16v-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Logo</span>';

    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/png,image/jpeg,image/webp,image/svg+xml';
    input.hidden = true;
    input.setAttribute('data-cc-logo-input', '');
    input.addEventListener('change', function () {
      var f = input.files && input.files[0];
      input.value = '';
      if (f) self.loadLogo(f);
    });
    this.modal.appendChild(input);

    b.addEventListener('click', function () {
      // Primer clic: sube. Si ya hay logo y no está seleccionado: lo selecciona. Si está seleccionado: lo reemplaza.
      if (self.logoEl && self.state.icon !== 'logo') self.selectIcon('logo');
      else input.click();
    });
    this.logoBtn = b;
    this.logoInput = input;

    // Celda con la X para quitar el logo
    var cell = document.createElement('div');
    cell.className = 'cc-logo-cell';
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'cc-logo-x';
    x.hidden = true;
    x.title = 'Remove logo';
    x.setAttribute('aria-label', 'Remove logo');
    x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
    x.addEventListener('click', function (e) { e.stopPropagation(); self.removeLogo(); });
    this.logoX = x;
    cell.appendChild(b);
    cell.appendChild(x);
    this.logoBtnHtml = b.innerHTML;
    return cell;
  };

  Customizer.prototype.removeLogo = function () {
    if (this.logoThumbUrl) { URL.revokeObjectURL(this.logoThumbUrl); this.logoThumbUrl = null; }
    this.logoFile = null;
    this.logoEl = null;
    this.logoBtn.classList.remove('has-logo');
    this.logoBtn.innerHTML = this.logoBtnHtml;
    this.logoBtn.title = 'Upload your logo';
    this.logoX.hidden = true;
    if (this.state.icon === 'logo') this.selectIcon(null);
    else this.markIcon();
  };

  Customizer.prototype.loadLogo = function (file) {
    var self = this;
    var maxMB = this.cfg.logoMaxMB || 5;
    if (!/^image\/(png|jpe?g|webp|svg\+xml)$/.test(file.type)) {
      this.showError('Please upload a PNG, JPG, WEBP or SVG file.');
      return;
    }
    if (file.size > maxMB * 1024 * 1024) {
      this.showError('Your logo must be ' + maxMB + ' MB or smaller.');
      return;
    }
    this.showError('');
    var reader = new FileReader();
    reader.onload = function () {
      var img = new Image();
      img.onload = function () {
        var el = self.engraveLogo(img);
        if (!el) { self.showError('We could not find a logo in that image. Try a file with a transparent or white background.'); return; }
        self.logoFile = file;
        self.logoEl = el;
        if (self.logoThumbUrl) URL.revokeObjectURL(self.logoThumbUrl);
        self.logoThumbUrl = URL.createObjectURL(file);
        self.logoBtn.classList.add('has-logo');
        self.logoBtn.title = 'Your logo (click again to replace)';
        // En el botón: colores originales. En el mockup: gris (grabado).
        self.logoBtn.innerHTML = '<img src="' + self.logoThumbUrl + '" alt="Your logo">';
        self.logoX.hidden = false;
        self.selectIcon('logo');
      };
      img.onerror = function () { self.showError('We could not read that image. Please try another file.'); };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  // Color del grabado en RGB (si el acabado es degradado, usa el tono medio)
  Customizer.prototype.engraveRgb = function () {
    var c = this.colors[this.state.color] || {};
    var hex = (c.stops ? c.stops[Math.floor(c.stops.length / 2)] : c.hex) || '#8a8f96';
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(function (x) { return x + x; }).join('');
    return [0, 2, 4].map(function (i) { return parseInt(hex.substr(i, 2), 16); });
  };

  // Convierte el logo en una silueta gris (como quedaría grabado):
  // - PNG/SVG con transparencia: la forma visible se pinta en gris.
  // - JPG/fondo opaco: lo claro (fondo blanco) se vuelve transparente y lo oscuro queda grabado.
  Customizer.prototype.engraveLogo = function (img) {
    var MAX = 900;
    var w = img.naturalWidth || 600, h = img.naturalHeight || 600;
    var k = Math.min(1, MAX / Math.max(w, h));
    w = Math.max(1, Math.round(w * k)); h = Math.max(1, Math.round(h * k));
    var cv = document.createElement('canvas');
    cv.width = w; cv.height = h;
    var ctx = cv.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, w, h);
    var data = ctx.getImageData(0, 0, w, h);
    var d = data.data;

    var sampled = 0, transparent = 0;
    for (var i = 3; i < d.length; i += 16) { sampled++; if (d[i] < 245) transparent++; }
    var useAlpha = transparent > sampled * 0.03;

    var mode = this.cfg.logoMode || 'gray';
    var rgb = this.engraveRgb();
    for (var j = 0; j < d.length; j += 4) {
      var lum = (0.299 * d[j] + 0.587 * d[j + 1] + 0.114 * d[j + 2]) / 255;
      var a = d[j + 3];
      // Fondo blanco de JPG/PNG opaco → transparente, con borde suave (sin cortes duros)
      if (!useAlpha) a = Math.round(clamp((0.97 - lum) / 0.1, 0, 1) * 255);
      if (mode === 'engrave') {
        if (!useAlpha) a = Math.round(clamp((0.92 - lum) * 1.6, 0, 1) * 255);
        d[j] = rgb[0]; d[j + 1] = rgb[1]; d[j + 2] = rgb[2];
      } else if (mode === 'gray') {
        // Mantiene los tonos del logo (detalle real) dentro del gris del grabado
        var k = 0.7 + lum * 0.55;
        d[j] = clamp(Math.round(rgb[0] * k), 0, 255);
        d[j + 1] = clamp(Math.round(rgb[1] * k), 0, 255);
        d[j + 2] = clamp(Math.round(rgb[2] * k), 0, 255);
      }
      // 'original': colores sin cambios
      d[j + 3] = a;
    }
    ctx.putImageData(data, 0, 0);
    return trimCanvas(cv);
  };

  // Recorta los bordes transparentes para que el recuadro quede ajustado al logo
  function trimCanvas(cv) {
    var ctx = cv.getContext('2d', { willReadFrequently: true });
    var w = cv.width, h = cv.height;
    var d = ctx.getImageData(0, 0, w, h).data;
    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        if (d[(y * w + x) * 4 + 3] > 12) {
          if (x < minX) minX = x; if (x > maxX) maxX = x;
          if (y < minY) minY = y; if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return null;
    var out = document.createElement('canvas');
    out.width = maxX - minX + 1; out.height = maxY - minY + 1;
    out.getContext('2d').drawImage(cv, minX, minY, out.width, out.height, 0, 0, out.width, out.height);
    return out;
  }

  Customizer.prototype.markFieldErrors = function () {
    var input = this.$('[data-cc-line="1"]');
    var icons = this.$('[data-cc-icons]');
    if (input) input.classList.add('is-error');
    if (icons) icons.classList.add('is-error');
    var field = input && input.closest('.cc-field');
    if (field && field.scrollIntoView) field.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  Customizer.prototype.clearFieldErrors = function () {
    var input = this.$('[data-cc-line="1"]');
    var icons = this.$('[data-cc-icons]');
    if (input) input.classList.remove('is-error');
    if (icons) icons.classList.remove('is-error');
    var err = this.$('[data-cc-error]');
    if (err && !err.hidden) this.showError('');
  };

  // ============================================================
  // PRECIO, CANTIDAD Y CARRITO
  // ============================================================
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Formulario de compra principal: el que contiene los botones de compra (no el de payment terms u otros)
  Customizer.prototype.productForm = function () {
    var scope = this.root.closest('.shopify-section, product-info, section, main') || document;
    var bb = scope.querySelector('buy-buttons, .buy-buttons, [data-cubitt-buy-buttons]');
    var f = bb && bb.closest('form');
    if (!f && bb && bb.getAttribute('form')) f = document.getElementById(bb.getAttribute('form'));
    return f || scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  };

  // El botón "Personalize it" va SIEMPRE justo encima del ADD TO CART.
  // Apps como PayPal Pay Later insertan su mensaje encima del botón después de cargar: si pasa, nos reacomodamos.
  Customizer.prototype.placeAboveAtc = function () {
    var self = this;
    var slot = this.root.closest('.cc-slot--above-atc');
    if (!slot) return;
    function atc() {
      var f = self.productForm();
      return f && (f.querySelector('buy-buttons button[type="submit"], .buy-buttons button[type="submit"]') || f.querySelector('button[type="submit"]'));
    }
    function place() {
      var b = atc();
      if (b && b.parentNode && b.previousElementSibling !== slot) b.parentNode.insertBefore(slot, b);
    }
    place();
    var f = this.productForm();
    var target = f && (f.parentNode || f);
    if (target && window.MutationObserver) {
      var mo = new MutationObserver(place);
      mo.observe(target, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 30000);
    }
    window.addEventListener('load', place);
  };

  Customizer.prototype.variantPrice = function () {
    var id = this.selectedVariantId();
    var p = id && this.cfg.variantPrices ? this.cfg.variantPrices[id] : null;
    return p != null ? p : (this.cfg.price || 0);
  };

  Customizer.prototype.money = function (cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: this.cfg.currency || 'USD' }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  };

  Customizer.prototype.setQty = function (n) {
    this.qty = clamp(isNaN(n) ? 1 : n, 1, 99);
    var input = this.$('[data-cc-qty]');
    if (input) input.value = this.qty;
    this.updateTotal();
  };

  Customizer.prototype.updateTotal = function () {
    var unit = this.variantPrice();
    var fee = this.cfg.feePrice || 0;
    var q = this.qty;
    var total = this.$('[data-cc-total]');
    if (total) total.textContent = this.money((unit + fee) * q);
    var br = this.$('[data-cc-breakdown]');
    if (br) {
      br.innerHTML = '<span>' + this.money(unit) + ' + ' + this.money(fee) + ' personalization</span>' +
        '<span>' + (q > 1 ? q + ' × ' + this.money(unit + fee) : '') + '</span>';
    }
    var id = this.selectedVariantId();
    var available = !id || !this.cfg.variantAvailable || this.cfg.variantAvailable[id] !== false;
    var btn = this.$('[data-cc-add]');
    if (btn) btn.disabled = this.busy || !available || !this.cfg.feeVariantId;
    var label = this.$('[data-cc-add-label]');
    if (label) label.textContent = this.busy ? 'Adding…' : (available ? 'Add to cart' : 'Sold out');
  };

  Customizer.prototype.showError = function (msg) {
    var el = this.$('[data-cc-error]');
    if (!el) { if (msg) alert(msg); return; }
    el.textContent = msg || '';
    el.hidden = !msg;
  };

  Customizer.prototype.setBusy = function (b) {
    this.busy = b;
    this.modal.classList.toggle('is-busy', b);
    this.updateTotal();
  };

  // Posición del diseño (en % de la imagen) para producción
  Customizer.prototype.layout = function () {
    var self = this;
    var out = {};
    [['text', this.text], ['graphic', this.icon]].forEach(function (pair) {
      var o = pair[1];
      if (!o || o.visible === false) return;
      o.setCoords();
      var b = o.getBoundingRect();
      var r = function (n) { return Math.round(n * 10) / 10; };
      out[pair[0]] = {
        x: r((b.left / LOGICAL_W) * 100), y: r((b.top / self.logicalH) * 100),
        w: r((b.width / LOGICAL_W) * 100), h: r((b.height / self.logicalH) * 100),
        angle: Math.round(o.angle || 0)
      };
    });
    return out;
  };

  Customizer.prototype.buildProperties = function (uid) {
    var s = this.state;
    var f = this.fonts[s.font];
    var props = { _cc_id: uid };
    var lines = [s.line1.trim(), s.twoLines ? s.line2.trim() : ''].filter(Boolean);
    if (s.upper) lines = lines.map(function (l) { return l.toUpperCase(); });
    if (lines.length) {
      props['Text'] = lines[0];
      if (lines[1]) props['Text line 2'] = lines[1];
      props['Font'] = f.name;
      var st = [];
      if (s.bold && f.bold) st.push('Bold');
      if (s.italic && f.italic) st.push('Italic');
      if (st.length) props['Style'] = st.join(', ');
    }
    if (s.icon && s.icon !== 'logo') props['Icon'] = this.icons[s.icon].name;
    if (this.cfg.feePrice) props['Personalization'] = '+' + this.money(this.cfg.feePrice);
    props['_cc_layout'] = JSON.stringify(this.layout());
    return props;
  };

  function dataUrlToFile(dataUrl, name) {
    var parts = dataUrl.split(',');
    var mime = parts[0].match(/:(.*?);/)[1];
    var bin = atob(parts[1]);
    var arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new File([arr], name, { type: mime });
  }

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function postJSON(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) { var e = new Error(d.description || d.message || ('HTTP ' + r.status)); e.status = r.status; throw e; }
        return d;
      });
    });
  }

  // Busca en /cart.js la línea principal de esta personalización
  Customizer.prototype.findLine = async function (uid, tries) {
    for (var t = 0; t < (tries || 1); t++) {
      try {
        var cart = await fetch(ROOT + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
        var item = cart.items.filter(function (i) {
          return i.properties && i.properties._cc_id === uid && !i.parent_relationship;
        })[0];
        if (item) return item.key;
      } catch (e) { /* reintenta */ }
      await sleep(700);
    }
    return null;
  };

  // Agrega el producto con el logo y el preview como archivos (formulario multipart nativo de Shopify,
  // enviado por un iframe oculto para no recargar la página).
  Customizer.prototype.addParentWithFiles = function (variantId, props, files, uid) {
    var self = this;
    return new Promise(function (resolve) {
      var name = 'cc-frame-' + uid;
      var iframe = document.createElement('iframe');
      iframe.name = name;
      iframe.hidden = true;
      iframe.setAttribute('aria-hidden', 'true');
      iframe.tabIndex = -1;

      var form = document.createElement('form');
      form.method = 'post';
      form.action = ROOT + 'cart/add';
      form.enctype = 'multipart/form-data';
      form.target = name;
      form.hidden = true;

      function field(n, v) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = n; i.value = v;
        form.appendChild(i);
      }
      try {
        field('id', variantId);
        field('quantity', self.qty);
        Object.keys(props).forEach(function (k) { field('properties[' + k + ']', props[k]); });
        Object.keys(files).forEach(function (k) {
          if (!files[k]) return;
          var i = document.createElement('input');
          i.type = 'file'; i.name = 'properties[' + k + ']';
          var dt = new DataTransfer();
          dt.items.add(files[k]);
          i.files = dt.files;
          form.appendChild(i);
        });
      } catch (e) {
        console.warn('[Cubitt] File upload not supported in this browser', e);
        resolve(null);
        return;
      }

      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        self.findLine(uid, 4).then(function (key) {
          iframe.remove(); form.remove();
          resolve(key);
        });
      }
      document.body.appendChild(iframe);
      document.body.appendChild(form);
      // El listener se agrega después de insertar el iframe para ignorar el load inicial de about:blank
      setTimeout(function () {
        iframe.addEventListener('load', finish);
        form.submit();
        setTimeout(finish, 30000);
      }, 0);
    });
  };

  // Respaldo: agrega el producto sin archivos (solo texto) si la subida falla
  Customizer.prototype.addParentJson = async function (variantId, props, hadLogo) {
    var p = Object.assign({}, props);
    if (hadLogo) p['Logo'] = 'Customer uploaded a logo (file upload failed — please contact the customer)';
    var res = await postJSON('cart/add.js', { items: [{ id: variantId, quantity: this.qty, properties: p }] });
    var item = res.items ? res.items[0] : res;
    return item.key;
  };

  // Línea de $8 anidada al producto (si el carrito no acepta anidadas, se agrega normal y el sync la mantiene)
  Customizer.prototype.addFee = async function (parentKey, uid) {
    var line = { id: this.cfg.feeVariantId, quantity: this.qty, properties: { _cc_id: uid } };
    try {
      await postJSON('cart/add.js', { items: [Object.assign({ parent_line_key: parentKey }, line)] });
    } catch (e) {
      console.warn('[Cubitt] Nested line failed, adding fee as a regular line', e);
      await postJSON('cart/add.js', { items: [line] });
    }
  };

  Customizer.prototype.notifyCart = function (cart) {
    document.dispatchEvent(new CustomEvent('rebuy:cart.change', { detail: cart }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var R = window.Rebuy;
    try {
      var p = R && R.Cart && typeof R.Cart.fetchCart === 'function' ? R.Cart.fetchCart() : null;
      Promise.resolve(p).then(function () {
        if (R && R.SmartCart && typeof R.SmartCart.show === 'function') R.SmartCart.show();
      });
    } catch (e) { console.warn('[Cubitt] Rebuy refresh failed', e); }
    this.root.dispatchEvent(new CustomEvent('cubitt:added', { bubbles: true, detail: { cart: cart } }));
  };

  Customizer.prototype.addToCart = async function () {
    if (this.busy) return;
    var s = this.state;
    var hasText = this.hasText();
    var hasLogo = s.icon === 'logo' && !!this.logoFile;
    var hasIcon = !!s.icon && s.icon !== 'logo';
    if (!hasText && !hasLogo && !hasIcon) {
      this.showError('Add your text, an icon or your logo to continue.');
      this.markFieldErrors();
      return;
    }
    var variantId = this.selectedVariantId();
    if (!variantId) { this.showError('Please select an option first.'); return; }
    if (!this.cfg.feeVariantId) { this.showError('Personalization is not available right now. Please try again later.'); return; }

    this.showError('');
    this.setBusy(true);
    var uid = 'cc' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    try {
      var props = this.buildProperties(uid);
      var files = {
        Preview: dataUrlToFile(this.exportImage(1000, 'jpeg'), 'preview-' + uid + '.jpg'),
        Logo: hasLogo ? this.logoFile : null
      };
      var parentKey = await this.addParentWithFiles(variantId, props, files, uid);
      if (!parentKey) {
        console.warn('[Cubitt] Upload with files failed, adding without files');
        parentKey = await this.addParentJson(variantId, props, hasLogo);
      }
      await this.addFee(parentKey, uid);
      var cart = await fetch(ROOT + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
      this.setBusy(false);
      this.close();
      this.notifyCart(cart);
    } catch (e) {
      console.error('[Cubitt] Add to cart failed', e);
      this.setBusy(false);
      this.showError(e && e.status === 422 && e.message ? e.message : 'We could not add your item. Please try again.');
    }
  };

  // ============================================================
  // DEBUG: ?cc_debug=1 → el recuadro se arrastra/redimensiona y devuelve el JSON del metafield
  // ============================================================
  Customizer.prototype.enableDebug = function () {
    if (this.debugOn || !this.guide) return;
    this.debugOn = true;
    var self = this;
    var g = this.guide;
    var c = this.canvas;
    g.set({
      selectable: true, evented: true, hasControls: true, lockRotation: true,
      opacity: 1, stroke: '#ff2d55', strokeDashArray: [6, 4], fill: 'rgba(255,45,85,0.06)',
      borderColor: '#ff2d55', cornerColor: '#ff2d55', cornerStrokeColor: '#ffffff',
      transparentCorners: false, cornerSize: 12, cornerStyle: 'rect', padding: 0, hoverCursor: 'move'
    });
    g.setControlsVisibility({ mtr: false });
    c.bringObjectToFront(g);
    c.setActiveObject(g);

    var panel = this.$('.cc-debug');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'cc-debug';
      panel.innerHTML = '<div class="cc-debug-head"><strong>cc_debug</strong><span>Drag / resize the red box</span></div>' +
        '<pre data-cc-debug-json></pre><button type="button" data-cc-debug-copy>Copy JSON</button>';
      this.$('.cc-stage').appendChild(panel);
      panel.querySelector('[data-cc-debug-copy]').addEventListener('click', function () {
        var txt = panel.querySelector('pre').textContent;
        var btn = this;
        (navigator.clipboard ? navigator.clipboard.writeText(txt) : Promise.reject()).then(function () {
          btn.textContent = 'Copied ✓';
          setTimeout(function () { btn.textContent = 'Copy JSON'; }, 1500);
        }).catch(function () { window.prompt('Copy this JSON:', txt); });
      });
    }

    function update() {
      var w = g.width * g.scaleX, h = g.height * g.scaleY;
      g.set({ width: w, height: h, scaleX: 1, scaleY: 1 });
      g.setCoords();
      var r = function (n) { return Math.round(n * 10) / 10; };
      self.cfg.area = {
        x: r((g.left / LOGICAL_W) * 100), y: r((g.top / self.logicalH) * 100),
        w: r((w / LOGICAL_W) * 100), h: r((h / self.logicalH) * 100)
      };
      [self.text, self.icon].forEach(function (o) { if (o) { self.fitInside(o); self.remember(o); } });
      var json = Object.assign({}, self.cfg.custom || {}, { area: self.cfg.area, maxChars: parseInt(self.cfg.maxChars, 10) || 20 });
      var str = JSON.stringify(json);
      panel.querySelector('pre').textContent = str;
      console.log('[Cubitt debug] custom.customizer =', str);
      c.requestRenderAll();
    }
    if (!this._debugBound) {
      this._debugBound = true;
      c.on('object:modified', function (e) { if (self.debugOn && e.target === self.guide) update(); });
    }
    update();
  };

  // ------------------------------------------------------------
  // Arranque
  // ------------------------------------------------------------
  function boot() {
    qsa(document, '[data-cc-root]').forEach(function (root) {
      if (!root.__cubittCustomizer) root.__cubittCustomizer = new Customizer(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.CubittCustomizer = { boot: boot };
})();
